export enum Languages {
    EN = 'EN',
    PL = 'PL',
    IT = 'IT',
    DE = 'DE',
    AR = 'AR'
}
